import { errors } from 'rfc9457';

import { readEnvVariable } from '../helpers';

export interface IS3Env {
  accessKeyId: string;
  secretAccessKey: string;
  endpoint: string;
}

export function getS3Env(): IS3Env {
  const accessKeyId = readEnvVariable('S3_ACCESS_KEY_ID');
  const secretAccessKey = readEnvVariable('S3_SECRET_ACCESS_KEY');
  const endpoint = readEnvVariable('S3_ENDPOINT');

  if (!accessKeyId) {
    throw errors.server.envNotSet('S3_ACCESS_KEY_ID');
  }

  if (!secretAccessKey) {
    throw errors.server.envNotSet('S3_SECRET_ACCESS_KEY');
  }

  if (!endpoint) {
    throw errors.server.envNotSet('S3_ENDPOINT');
  }

  return { accessKeyId, secretAccessKey, endpoint };
}
